'use strict';

import errorNotice from './../error';
import totalChart from './sewage-total-chart';
import areaChart from './sewage-area';
import compareChart from './sewage-compare';

const sewageCharts = (function(){

    function init(data) {
        if (typeof data.sewage !== 'undefined' && data.sewage.weeks.length) {
            // Init charts
            totalChart.init(data.sewage);
            areaChart.init(data.sewage);
            compareChart.init(data.sewage);
        } else {
            const error = 'Ongelma havaittu, dataa jätevesistä ei saatavilla.';
            errorNotice.showDataError(error, '.sewage-data-area');
        }
    }

    function reload(data, page) {
        totalChart.reload(data.sewage);
        areaChart.reload(data.sewage);
        compareChart.reload(data.sewage);

        page.classList.remove('reload');
    }

    return {
        init,
        reload,
    }
})();

export default sewageCharts;
